import { gql } from '@apollo/client';

export const GET_NOTIFICATION_CONFIGS = gql`
  query GetNotificationConfigs {
    vm {
      notificationConfigs {
        notificationConfigId
        notificationType
        notifyAdmins
        notifyProgramManagers
        notifyActivityLeaders
        notifySpecificManagers
        customEmail
        isEnabled
        managers {
          managerId
          profile {
            profileId
            preferredName
            lastName
            email
            avatarUrl
          }
        }
      }
    }
  }
`;